import { keyframes } from "styled-components";

export const fadeOutOpacity = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const translateUp = keyframes`
  from {
    transform: translate3d(0, 100vh, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
`;
